import { render, staticRenderFns } from "./MollieTab.vue?vue&type=template&id=22487de1&scoped=true&"
import script from "./MollieTab.vue?vue&type=script&lang=js&"
export * from "./MollieTab.vue?vue&type=script&lang=js&"
import style0 from "./MollieTab.vue?vue&type=style&index=0&id=22487de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22487de1",
  null
  
)

export default component.exports